<template>
  <div class="box px-3 py-3">
    <p class="has-text-weight-medium has-text-centered mb-1">
      {{ $t('batchesSchedules.title') }}
    </p>
    <div v-if="loading">
      <button class="button is-white is-fullwidth is-loading"></button>
    </div>
    <div v-else>
      <table class="table is-striped">
        <tbody>
          <tr v-for="({ provider, next_execution }) in schedules" :key="provider">
            <td>{{ $t(`batchesSchedules.providers.${provider}`) }}</td>
            <td>{{ $t('batchesSchedules.fromNowLabel', { time: distance(next_execution) }) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-if="inError" class="has-text-danger is-size-7">
      {{ $t('batchesSchedules.error') }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'BatchesSchedules',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    loading: false,
    inError: false,
    schedules: []
  }),
  watch:{
    'isVisible': function(isVisibleNow) {
      if(isVisibleNow) {
        this.fetchSchedules()
      }
    }
  },
  methods: {
    distance(nextExecution) {
      return this.$options.filters.time_from_now(nextExecution, 'YYYY-MM-DDTHH:mm:ss+ZZ') 
    },
    fetchSchedules() {
      this.inError = false
      this.loading = true
      this.$repositories()
          .batches
          .schedules()
          .then(res => ( this.schedules = [...res] ))
          .catch(() => ( this.inError = true ))
          .finally(() => ( this.loading = false ))
    }
  }
}
</script>
<style lang="scss">
.tooltip {
  z-index: 1000;
  max-width: 28vw;
}
</style>
